import * as firebase from "firebase";
const firebaseConfig = {
  apiKey: "AIzaSyBlBJtz1oV7_pWAyjrlkxdJ7ZenisHP5sk",
  databaseURL: "https://boltconcierge-2f0f9.firebaseio.com",
  storageBucket: "boltconcierge-2f0f9.appspot.com"
};

class Firebase {
  static initialize() {
    firebase.initializeApp(firebaseConfig);
  }
  //
  static storage() {
    return firebase.storage();
  }
  static getStorage() {
    return firebase.storage;
  }
  static getAllBrands = callback => {
    console.log("getAllBrands");
    let path = "brands";
    firebase
      .database()
      .ref(path)
      .on("value", snapshot => {
        var res = [];
        if (snapshot.val()) {
          res = snapshot.val();
        }
        callback(res);
      });
  };
  static getProfileByUID = (uid, brand) => {
    console.log("uid", uid);
    console.log("brand", brand);
    return new Promise((resolve, reject) => {
      if (brand !== "Bolt") {
        firebase
          .firestore()
          .collection(`${brand}`)
          .doc("data")
          .collection("user")
          .doc(uid)
          .get()
          .then(res => {
            if (res.data()) resolve(res.data());
            else resolve(false);
          })
          .catch(err => {
            reject(err);
          });
      } else {
        firebase
          .firestore()
          .collection(`user`)
          .doc(uid)
          .get()
          .then(res => {
            if (res.data()) resolve(res.data());
            else resolve(false);
          })
          .catch(err => {
            reject(err);
          });
      }
    });
  };
  static writeUserdata(userid, data) {
    let path = "user/" + userid;
    console.log(data);
    firebase
      .database()
      .ref(path)
      .set(data);
  }
  static getUserData(userid, callback) {
    let path = "user/" + userid;

    firebase
      .database()
      .ref(path)
      .once("value", snapshot => {
        var res = [];

        if (snapshot.val()) {
          res = snapshot.val();
        }

        callback(res);
      });
  }
  static getUsersData(callback) {
    console.log("getUsersData");
    let path = "user/";
    firebase
      .database()
      .ref(path)
      .on("value", snapshot => {
        var res = [];

        if (snapshot.val()) {
          res = snapshot.val();
        }

        callback(res);
      });
  }
  static getCountChild(name, callback) {
    let path = name + "/";
    firebase
      .database()
      .ref(path)
      .on("value", snapshot => {
        var res = [];

        if (snapshot.val()) {
          res = snapshot.val();
        }
        var length = Object.keys(res).length;
        callback(length);
      });
  }
}
Firebase.initialize();
export default Firebase;



// WEBPACK FOOTER //
// ./src/firebasehelper/index.js